define('view/module/GdprReportView',['require','lib/view/FormView','lib/view/UnwrapBehavior','Config'],function (require) {

    var FormView = require('lib/view/FormView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    return FormView.extend({

        template: '#gdpr_report_module',

        modelEvents:  {
            'sync': 'render',
            'change': 'render',
            'invalid' : 'render'
        },

        ui: {
            data : ':input',
            submitButton : ':input[type=submit]',
            showFormBtn : '#sb_gdpr_show_form_btn',
            closeFormBtn : '.sb_gdpr_close_form_btn',
            sendAgainBtn : '#sb_gdpr_repeat_submit',
            sendToAnotherBtn : '#sb_gdpr_send_another',

            emailInput : '#sb_gdpr_form_email',
            phoneInput : '#sb_gdpr_form_phone',

            gdprForm : '#sb_gdpr_report_module_container'
        },

        events : {
            'click @ui.showFormBtn' : 'onShowForm',
            'click @ui.submitButton' : 'onSubmit',
            'click @ui.closeFormBtn' : 'onCloseForm',
            'click @ui.sendAgainBtn' : 'onSubmitAgain',
            'click @ui.sendToAnotherBtn' : 'onSendToAnother',
            'keyup @ui.emailInput' : 'onEmailInputChange',
            'keyup @ui.phoneInput' : 'onPhoneInputChange',
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        lastData : null,
        sendCounter : 0,

        initialize: function (options) {

        },

        onEmailInputChange: function(){
            var emailNode = jQuery(this.ui.emailInput);
            var phoneNode = jQuery(this.ui.phoneInput);

            if(emailNode && emailNode.val().length){
                phoneNode.attr('disabled', 'disabled');
            } else{
                phoneNode.removeAttr('disabled');
            }
        },

        onPhoneInputChange: function(){
            var emailNode = jQuery(this.ui.emailInput);
            var phoneNode = jQuery(this.ui.phoneInput);

            if(phoneNode && phoneNode.val().length){
                emailNode.attr('disabled', 'disabled');
            } else{
                emailNode.removeAttr('disabled');
            }
        },

        serializeData: function () {
            var res = this._serializeData();
            if(res && res.data){
                res.show_email_input = true;
                if ( ( res.data.email || res.data.phone) && !res.errors){
                    res.show_email_input = false;
                }
                if(res.data.code){
                    res.show_email_input = false;
                }
                if(res.errors && res.errors.code){
                    res.show_email_input = false;
                }
            }
            if(this.sendCounter>1){
                res.message = Locale.getNonEscape('the code was sent again');
            }

            return res;
        },

        onShowForm : function () {
            this.model.set('is_form_active', !this.model.get('is_form_active'));
            return false;
        },

        onCloseForm : function (e) {
            this.model.set('is_form_active', false);
            return false;
        },

        onSubmit  : function (e) {
            e.stopPropagation(); // to prevent closing popup on submit button
            this.lastData = this._getData(this.ui.data);
            this.sendCounter = 1;
            this._submit(this.lastData);
        },

        _submit : function(data){
            this.model.set(data);
            this.model.save(null, {
                success: _.bind(function () {
                    this.onAuthorized();
                }, this),
                error: _.bind(function (model, xhr) {
                    this.model.onError(model, xhr);
                }, this),
            });
        },

        onAuthorized : function () {
            if(this.model.get('result')){
                Backbone.history.navigate('gdpr-report', {
                    trigger: true
                });
                this.model.set('is_form_active', false);
                jQuery(window).scrollTop(0);
            }
        },

        onSubmitAgain : function(){
            if(this.lastData){
                this.sendCounter++;
                this._submit(this.lastData);
            }
            return false;
        },

        onSendToAnother : function () {
            this.model.validationError = null;
            this.model.set({
                email : '',
                phone : '',
                code: ''
            });
            return false;
        },

    });
});

